import apiSlice from '../../services/api/slice'

const versionSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRequiredVersion: builder.query({
      query: (platform) => ({ url: `/v1/version/${platform}`, method: 'GET' }),
      transformResponse: (response) => response.data,
    }),
  }),
})

export const { useGetRequiredVersionQuery } = versionSlice
